import TimeFormatter from "../TimeFormatter"

export const setDate=(date)=> {
    let dateObj = TimeFormatter(date)
    let str = dateObj.userSplitedDate[2] + ' ' + dateObj.ShiftMonth + ' ' + dateObj.userSplitedDate[0]
    return str
  }